import Subscription from './modules/account-subscription';
import AccountComposer from "./modules/account-composer";
import AccountNotificationForm from "./modules/notification-form";
import axios from "axios";
import Downloads from "./modules/account-downloads";
import AccountActivations from "./modules/account-activations";

document.addEventListener('DOMContentLoaded', () => {

    // Register Subscription element
    document.querySelectorAll<HTMLElement>('.woocommerce-MyAccount-content .subscription').forEach(subscriptionElement => {
        (new Subscription(subscriptionElement)).register();
    });

    document.querySelectorAll<HTMLElement>('[data-component="subscriptionActivations"]').forEach(component => {
        new AccountActivations(component);
    });

    // Register Composer element
    document.querySelectorAll<HTMLElement>('#composerSection').forEach(el => new AccountComposer(el));

    // Register Notification Form (Account settings)
    document.querySelectorAll<HTMLFormElement>('#accountNotificationSettings form').forEach(el => new AccountNotificationForm(el));


    // Calculated Price by Ajax (Subscription Details)
    document.querySelectorAll<HTMLElement>('[data-get-calculated-price]').forEach((el) => {
        axios.get(el.dataset.getCalculatedPrice!).then((response) => {
            if (response.status === 200 && response.data.success) {
                el.innerHTML = response.data.data;
            } else {
                el.innerHTML = 'Price could not be calculated';
            }
        })
    });

    // init Download Table
    document.querySelectorAll<HTMLTableElement>('.woocommerce-order-downloads table').forEach(el => {
        new Downloads(el);
    });

});